import RobotAccordion from './RobotAccordion';
import styles from './SelectOptionItem.module.scss';

function SelectOptionItem({
  selected,
  disabled,
  onClick,
  data,
  displayPrimaryButton,
  shouldDisplayPrice,
  highlighted,
}) {
  let containerClassName = styles.service_container;
  if (selected) {
    containerClassName += ` ${styles.selectedItemStyle}`;
  }
  if (disabled) {
    containerClassName += ` ${styles.disabledItemStyle}`;
  }
  if (highlighted) {
    containerClassName += ` ${styles.highlightedItemStyle}`;
  }

  let item;
  switch (data.type) {
    case 'service':
      item = (
        <div className={containerClassName} onClick={onClick}>
          <p className={styles.title}>{data.title}</p>
          <p className={styles.description}>{data.description}</p>
        </div>
      );
      break;

    case 'robot':
      item = (
        <RobotAccordion
          selected={selected}
          disabled={disabled}
          data={data}
          onClick={onClick}
          displayPrimaryButton={displayPrimaryButton}
          shouldDisplayPrice={shouldDisplayPrice}
        />
      );
      break;

    default:
      item = null;
      break;
  }

  return item;
}

export default SelectOptionItem;
